import Vue from 'vue';
import VueRouter from 'vue-router';
import VueBodyClass from 'vue-body-class';

import Login from 'views/login/Login';
import LoginEmail from 'views/login/LoginEmail';
import ApplicationMain from 'views/application/Main.vue';
import ApplicationAdditional from 'views/application/Additional.vue';
import Find from 'views/login/Find';
import FindId from 'views/login/FindId';
import FindPassword from 'views/login/FindPassword';
import NaverRepeater from 'views/login/NaverRepeater';
import KakaoRepeater from 'views/login/KakaoRepeater';
import DialogUtil from 'utils/dialog';
import HeaderUtil from 'utils/header';
import Store from 'store';
import config from 'config';
import { postMessageToPlanHome } from 'utils/webview/postMessageToPlanHome';
import { isWebview } from 'utils/webview/isWebview';
import { closeWebView } from 'utils/webview/closeWebView';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      bodyClass: 'page-login',
    },
  },
  {
    path: '/login/email',
    name: 'LoginEmail',
    component: LoginEmail,
    meta: {
      bodyClass: 'page-login',
    },
  },
  {
    path: '/application/main/:step',
    name: 'Application',
    component: ApplicationMain,
    props: true,
    meta: {
      bodyClass: 'page-login',
    },
  },
  {
    path: '/application/additional/:step',
    name: 'ApplicationAdditional',
    component: ApplicationAdditional,
    props: true,
    meta: {
      bodyClass: 'page-login',
    },
  },
  {
    path: '/find',
    name: 'Find',
    component: Find,
    meta: {
      bodyClass: 'page-find',
    },
    children: [
      {
        path: '/find',
        alias: '/find/id',
        name: 'FindID',
        component: FindId,
      },
      {
        path: '/find/password',
        name: 'FindPassword',
        component: FindPassword,
      },
    ],
  },
  {
    path: '/naver_repeater',
    name: 'NaverRepeater',
    component: NaverRepeater,
  },
  {
    path: '/kakao_repeater',
    name: 'KakaoRepeater',
    component: KakaoRepeater,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

const vueBodyClass = new VueBodyClass(routes);
router.beforeEach((to, from, next) => {
  const { params, query } = to;
  if (to.path === '/') {
    next({ path: '/application/main?force=true', params, query, replace: true });
    location.reload(true);
  } else if (to.path === '/application/main') {
    next({ path: '/application/main/1', params, query, replace: true });
  } else if (from.path === '/application/main/7') {
    if (to.path === '/application/main/6') {
      DialogUtil.alert('잘못된 접근입니다.\n플랜 홈으로 이동합니다.');
      if (isWebview()) {
        postMessageToPlanHome('/');
        closeWebView();
        return;
      }
      window.location.href = config.planHome.baseURL;
    } else {
      vueBodyClass.guard(to, next);
    }
  } else if (to.path === '/application/main/7') {
    if (from.path !== '/application/main/6') {
      DialogUtil.alert('잘못된 접근입니다.\n플랜 홈으로 이동합니다.');
      if (isWebview()) {
        postMessageToPlanHome('/');
        closeWebView();
        return;
      }
      window.location.href = config.planHome.baseURL;
    } else {
      vueBodyClass.guard(to, next);
    }
  } else if (to.path === '/application/additional') {
    next({ path: '/application/additional/1', params, query });
  } else {
    vueBodyClass.guard(to, next);
  }
  const cookieName = HeaderUtil.isWebView() ? 'auth_token' : 'plan_auth_token';
  const authToken = HeaderUtil.getCookie(cookieName);
  if (authToken == null) {
    Store.dispatch('user/logout');
    Store.dispatch('updateAccessToken', '');
    window.gtag('set', 'user_properties', {
      user_id: '',
    });
  }
});

export default router;
